import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ChatService} from '../../services/chat.service';
import {ChatRoomDto} from '../../models/createChatRoomRequest';
import {DomSanitizer} from '@angular/platform-browser';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';
import {LoggerService} from '../../../logging/services/logger.service';

@Component({
  selector: 'app-chat-room-list',
  templateUrl: './chat-room-list.component.html',
  styleUrls: ['./chat-room-list.component.scss']
})
export class ChatRoomListComponent implements OnInit {

  @Output() selectChatEvent = new EventEmitter<ChatRoomDto>();

  get chatRooms(): ChatRoomDto[] {
    return this.chatService.chatRooms;
  }

  constructor(private chatService: ChatService,
              private sanitizer: DomSanitizer,
              private loggingService: LoggerService) { }

  async ngOnInit(): Promise<void> {
  }

  getRoomName(room: ChatRoomDto) {
    return room.room.name;
  }

  getRoomPreview(room: ChatRoomDto) {
    if (room.messages.length > 0) {
      const lastMessage =  room.messages[room.messages.length - 1];
      const author = room.participants.find(p => p.accountId === lastMessage.createdBy);
      return `<b>${author.username}</b>: ${lastMessage.message}`;
    }
    return 'No messages yet';
  }

  getRoomLastMessageTimestamp(room: ChatRoomDto) {
    if (room.messages.length > 0) {
      const now = new Date();
      const creationDate = new Date(room.messages[room.messages.length - 1].creationDate);
      const diff = Math.abs(now.getTime() - creationDate.getTime());
      const minutes = Math.floor(diff / 60000);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) {
        return `${days} day${(days > 1 ? 's' : '')} ago`;
      } else if (hours > 0) {
        return `${hours} hour${(hours > 1 ? 's' : '')} ago`;
      } else {
        return `${minutes} minute${(minutes > 1 ? 's' : '')} ago`;
      }
    }
    return 'No messages yet';
  }

  selectChat(room: ChatRoomDto) {
    this.selectChatEvent.emit(room);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.ChatRoomList, 'Selected chat room with id ' + room.room.id);
  }

  getCircleStyle(room: ChatRoomDto) {
    if (room === null || room === undefined) {
      return this.sanitizer.bypassSecurityTrustStyle('');
    } else {
      const myrng = Math.random();
      const hue = myrng * 360;

      const htmlStyle = `background: linear-gradient(165deg, hsl(${hue},100%,50%) 0%, hsl(${hue},100%,18%) 100%);`;

      return this.sanitizer.bypassSecurityTrustStyle(htmlStyle);
    }
  }
}
